import apiClient from '../apiClient';
import { POST_CUSTOMER_PROFILE_URL } from '../apiUrl';

const postCustomerProfileApi = data => {
  return apiClient.post(POST_CUSTOMER_PROFILE_URL, data);
};

export default postCustomerProfileApi;
